import React from 'react';
import ShareImage from './ShareImage';
import './App.css';

const main_title= 'https://itreeware.s3-us-west-2.amazonaws.com/ChangeMyView/ChangeMyView_Title11.png';

const BlightedLot_1= 'https://itreeware.s3-us-west-2.amazonaws.com/ChangeMyView/Change+My+View+1.gif';
const BlightedLot_2= 'https://itreeware.s3-us-west-2.amazonaws.com/ChangeMyView/Garden+1+Change+My+View.gif';
const BlightedLot_3= 'https://itreeware.s3-us-west-2.amazonaws.com/ChangeMyView/Garden+2+Change+My+View.gif';
const BlightedLot_4= 'https://itreeware.s3-us-west-2.amazonaws.com/ChangeMyView/Garden+3+Change+My+View+.gif';
const BlightedLot_5= 'https://itreeware.s3-us-west-2.amazonaws.com/ChangeMyView/Garden+4+Change+My+View+.gif';
const BlightedLot_6= 'https://itreeware.s3-us-west-2.amazonaws.com/ChangeMyView/Change+My+View+2.gif';
const BlightedLot_7= 'https://itreeware.s3-us-west-2.amazonaws.com/ChangeMyView/Change+My+View+3.gif';
const BlightedLot_8= 'https://itreeware.s3-us-west-2.amazonaws.com/ChangeMyView/Change+My+View+4.gif';

const desc1= 'Check out what my South side neighborhood lots abandon lots can look like!  Who wants to get involved?';
const desc2= 'Everyone knows natural beauty is healing- look at this change. Who wants to get involved?';
const desc3= 'My aunt used to life here.';
const loc1= 'Englwood Chicago, IL';
const loc2= 'Woodlawn Chicago, IL';
const loc3= 'Pilson Chicago, IL';
const loc4= 'Little Havana, MI USA';
const loc5= 'Wounded Knee, SD USA';
const loc6= 'Daxihe Village, Guizhou China';
const loc7= 'Chiapas, Mexico';
const loc8= 'Basanti, Kolkata, India';
const loc9= 'Daxihe Village, Guizhou China';
const title1= 'Down The Street';
const title2= 'Ugly on My Block';
const title3= 'Pretty Again!';

const favorited= 'https://itreeware.s3-us-west-2.amazonaws.com/ChangeMyView/favorited.png';
const not_favorited= 'https://itreeware.s3-us-west-2.amazonaws.com/ChangeMyView/not_favorited.png';

const add_picture='https://itreeware.s3-us-west-2.amazonaws.com/ChangeMyView/add_picture.png';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={main_title} className="App-logo" alt="logo" />
      
      <h4 className="instructions"> Change My View is an app that engages your physical neighborhood.  Get up and WALK to the target locations identified for your block.  THEN apply beautification filters to CHANGE YOUR VIEW. Just look at what has been transformed already!!! </h4>
        <div className="App-container">
        <img src={add_picture} className="favorite_me" alt="logo" />
          <ShareImage loc={loc1}  title={title1}  desc={desc2}  img={BlightedLot_1} liked={favorited}/>
          <ShareImage loc={loc2}  title={title2}  desc={desc3}  img={BlightedLot_2} liked={favorited}/>
          <ShareImage loc={loc3}  title={title3}  desc={desc1}  img={BlightedLot_3} liked={favorited}/>
          <ShareImage loc={loc4}  title={title1}  desc={desc2}  img={BlightedLot_4} liked={favorited}/>
          <ShareImage loc={loc5}  title={title2}  desc={desc3}  img={BlightedLot_5} liked={favorited}/>
          <ShareImage loc={loc6}  title={title3}  desc={desc1}  img={BlightedLot_6} liked={favorited}/>
          <ShareImage loc={loc7}  title={title1}  desc={desc2}  img={BlightedLot_7} liked={favorited}/>
          <ShareImage loc={loc8}  title={title2}  desc={desc3}  img={BlightedLot_8} liked={favorited}/>
          <ShareImage loc={loc9}  title={title3}  desc={desc1}  img={BlightedLot_1} liked={favorited}/>
          <ShareImage loc={loc1}  title={title1}  desc={desc2}  img={BlightedLot_2} liked={favorited}/>
          <ShareImage loc={loc2}  title={title2}  desc={desc3}  img={BlightedLot_3} liked={favorited}/>
          <ShareImage loc={loc3}  title={title3}  desc={desc1}  img={BlightedLot_4} liked={favorited}/>
          <ShareImage loc={loc1}  title={title1}  desc={desc2}  img={BlightedLot_5} liked={favorited}/>
          <ShareImage loc={loc5}  title={title2}  desc={desc3}  img={BlightedLot_6} liked={favorited}/>
          <ShareImage loc={loc6}  title={title3}  desc={desc1}  img={BlightedLot_7} liked={favorited}/>
          <ShareImage loc={loc7}  title={title1}  desc={desc2}  img={BlightedLot_8} liked={favorited}/>
          <ShareImage loc={loc8}  title={title2}  desc={desc3}  img={BlightedLot_1} liked={favorited}/>
          <ShareImage loc={loc9}  title={title3}  desc={desc1}  img={BlightedLot_2} liked={favorited}/>
          <ShareImage loc={loc3}  title={title3}  desc={desc1}  img={BlightedLot_3} liked={favorited}/>
          <ShareImage loc={loc1}  title={title1}  desc={desc2}  img={BlightedLot_4} liked={favorited}/>
          <ShareImage loc={loc2}  title={title2}  desc={desc3}  img={BlightedLot_5} liked={favorited}/>
          <ShareImage loc={loc3}  title={title3}  desc={desc1}  img={BlightedLot_6} liked={favorited}/>
          <ShareImage loc={loc8}  title={title1}  desc={desc2}  img={BlightedLot_7} liked={favorited}/>
          <ShareImage loc={loc9}  title={title2}  desc={desc3}  img={BlightedLot_8} liked={favorited}/>

        
        </div>

      </header>
    </div>
  );
}

export default App;
